import React from 'react';
import PropTypes from 'prop-types';

const Megaphone = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="292"
    height="322"
    viewBox="0 0 292 322"
  >
    <g fill="none">
      <path
        fill="#DC9F6F"
        d="M202.684 256.599c2.045 5.327-.687 11.673-6.692 13.978l-40.913 15.705c-5.63 2.161-12.658-.438-14.703-5.765-7.634-19.889-12.34-25.417-7.696-35.757 2.732-6.345 70.004 11.839 70.004 11.839z"
      />
      <path
        fill="#EBECEE"
        d="M179.673 240.435l-17.112-11.297-9.012 13.652 17.113 11.297z"
      />
      <path
        fill="#32B395"
        d="M231.87 219.317s-23.956 11.64-43.044 52.788c-2.629 5.492-9.385 8.085-15.014 5.764l-16.885-6.966c-6.14-2.532-16.234-15.364-12.717-20.789 7.988-12.846 21.814-34.045 42.055-56.484l45.604 25.687z"
      />
      <path
        fill="#264348"
        d="M231.87 219.317s-23.956 11.64-43.044 52.788c-2.629 5.492-9.385 8.085-15.014 5.764l-16.885-6.966c-6.14-2.532-16.234-15.364-12.717-20.789 7.988-12.846 21.814-34.045 42.055-56.484l45.604 25.687z"
        opacity="0.96"
      />
      <path
        fill="#ECC197"
        d="M194.254 278.171L150.31 295.04l2.779 12.615 54.496-1.298-6.285-13.317z"
      />
      <path
        fill="#DC9F6F"
        d="M150.494 307.655h27.248l-11.81-31.244-25.828 3.395z"
      />
      <path
        fill="#ECC197"
        d="M206.443 241.71l18.047 3.259-23.902 49.923c-3.108 6.49-11.229 10.014-18.392 7.06l-8.323-3.733s-16.75-6.61-10.91-19.445c7.307-14.622 28.195-36.495 43.48-37.065zM162.069 210.253c-3.001-3.33-8.187-3.377-11.77-.372-3.584 3.006-3.825 7.988-.824 11.318l19.439 21.47c3 3.33 8.186 3.377 11.77.371 3.583-3.005 3.824-7.988.823-11.318l-19.438-21.469z"
      />
      <path
        fill="#F8DDB1"
        d="M177.175 230.533l3.137 3.685c1.432 1.488.988 3.696-.616 5.127l-3.584 3.005c-1.604 1.43-3.89 1.086-5.322-.402l-3.137-3.685 9.522-7.73z"
      />
      <path
        fill="#ECC197"
        d="M154.045 226.372c-3.001-3.33-8.187-3.377-11.77-.371-3.584 3.005-3.825 7.988-.824 11.318l19.439 21.469c3 3.33 8.186 3.377 11.77.372 3.583-3.006 3.824-7.988.823-11.318l-19.438-21.47z"
      />
      <path
        fill="#F8DDB1"
        d="M169.662 246.863l3.138 3.686c1.432 1.487.988 3.695-.616 5.126l-3.584 3.006c-1.604 1.43-3.89 1.085-5.322-.402l-3.137-3.686 9.521-7.73z"
      />
      <path
        fill="#ECC197"
        d="M146.396 242.348c-3-3.33-8.187-3.377-11.77-.372-3.584 3.006-3.824 7.988-.823 11.318l19.438 21.47c3 3.33 8.187 3.376 11.77.37 3.584-3.005 3.825-7.987.824-11.317l-19.439-21.47z"
      />
      <path
        fill="#F8DDB1"
        d="M161.638 262.983l3.138 3.685c1.432 1.488.988 3.696-.616 5.126l-3.584 3.006c-1.604 1.43-3.89 1.086-5.322-.402l-3.137-3.685 9.521-7.73z"
      />
      <path
        fill="#32B395"
        d="M207.506 306.254l-57.083.996.28 15.975 57.081-.997zM220.687 112.776l55.261 22.794c13.816 5.7 19.814 21.326 13.497 35.16l-9.8 20.468-9.56 19.97c-6.693 13.978-23.584 20.462-37.911 14.552l-54.886-22.94 43.4-90.004z"
      />
      <path
        fill="#FFF"
        d="M211.989 109.187l3.07 1.267-21.512 44.93-21.512 44.931-3.07-1.266c-20.704-12.427-122.126-35.431-149.877-1.145l46.028-95.496 45.892-95.852c-8.955 41.74 81.981 92.403 100.98 102.631zM18.554 83.2c5.736-11.98 20.375-17.6 32.655-12.534L40.93 92.132 30.653 113.6c-12.52-4.566-17.836-18.417-12.1-30.398z"
      />
      <path
        fill="#32B395"
        d="M279.509 190.843l-9.561 19.97c-6.693 13.978-23.583 20.461-37.91 14.552L177.8 202.992l21.512-44.93 80.197 32.781z"
      />
      <path
        fill="#EBECEE"
        d="M190.477 154.118l3.07 1.266-21.512 44.931-3.07-1.266c-19.137-6.1-122.126-35.431-149.877-1.145l46.028-95.496 125.36 51.71z"
      />
      <path
        fill="#EBECEE"
        d="M259.697 165.035c-1.024-.422-1.433-1.488-.818-2.13.478-1 1.604-1.432 2.252-.865l27.119 11.186-1.434 2.995-27.12-11.186zM251.809 181.51c-1.023-.423-1.432-1.488-.818-2.131.478-.999 1.604-1.431 2.252-.865l27.119 11.187-1.57 2.64-26.983-10.831zM244.16 197.485c-1.023-.422-1.432-1.488-.818-2.13.478-1 1.604-1.432 2.252-.865l27.12 11.186-1.435 2.995-27.119-11.186z"
      />
      <path
        fill="#32B395"
        d="M215.434 110.31l5.765 2.677-21.512 44.93-21.512 44.93-6.004-2.177 21.376-45.286z"
      />
      <path
        fill="#C73C3C"
        d="M199.687 157.917l-21.512 44.93-6.004-2.177 21.376-45.286 21.887-45.074 5.765 2.677"
        opacity="0.5"
      />
      <path
        fill="#32B395"
        d="M1.356 174.15l29.058-60.052 10.142-21.822L50.834 70.81 80.369 9.76c3.21-7.345 12.219-10.803 19.894-7.637l10.745 4.433-45.892 95.852-45.892 95.852-10.233-4.222c-7.675-3.166-11.084-12.044-7.635-19.888z"
      />
      <path
        fill="#EBECEE"
        d="M18.554 83.2l22.002 9.076-10.278 21.467c-12.144-4.71-17.46-18.56-11.724-30.542z"
      />
      <path
        fill="#ECC197"
        d="M169.718 194.278c-3.001-3.33-8.187-3.377-11.77-.372-3.584 3.006-3.825 7.988-.824 11.318l19.438 21.47c3.001 3.33 8.187 3.376 11.77.37 3.584-3.005 3.825-7.987.824-11.317l-19.438-21.47z"
      />
      <path
        fill="#F8DDB1"
        d="M184.823 214.558l3.138 3.685c1.432 1.488.988 3.696-.616 5.126l-3.584 3.006c-1.604 1.43-3.89 1.085-5.322-.402l-3.137-3.686 9.521-7.73z"
      />
      <path
        fill="#ECC197"
        d="M212.718 249.08a9.342 9.342 0 0 0 12.01-4.61c2.152-4.494.243-9.466-4.362-11.365l-25.072-10.342a9.342 9.342 0 0 0-12.011 4.61c-2.151 4.493-.243 9.465 4.363 11.365l25.072 10.342z"
      />
      <path
        fill="#ECC197"
        d="M190.818 239.15c5.186.047 9.248-3.957 9.113-8.795.24-4.983-3.783-8.735-8.833-8.427l-19.72.236c-5.186-.047-9.247 3.957-9.113 8.795-.24 4.982 3.784 8.734 8.833 8.426l19.72-.235z"
      />
      <path
        fill="#F8DDB1"
        d="M175.978 237.512l-5.937.241c-2.524.155-4.093-1.688-4.16-4.107l.24-4.982c-.067-2.42 1.913-3.994 4.437-4.148l5.937-.242-.517 13.238z"
      />
      <path
        fill="#3C3C3C"
        d="M279.509 190.843l-9.561 19.97c-6.693 13.978-23.583 20.461-37.91 14.552L177.8 202.992l21.512-44.93 80.197 32.781z"
        opacity="0.25"
      />
    </g>
  </svg>
);

Megaphone.propTypes = {
  className: PropTypes.string.isRequired
};

export default Megaphone;
